import { LANDSCAPE_BACKDROPS } from '../../../game/effects/atmosphere/silhouettes/landscapeBackdrops';
import { ATMOSPHERE_PALETTE as P } from '../palette';
import { forestBiome } from '../biomeArchetypes';

/** Coast / Sunkissed Shore — a bright tropical beach ABOVE the surface (distinct from underwater):
 *  a pale-blue sky with a high sun + warm halo, soft drifting tropical clouds, twinkling sea-spray
 *  motes, bright sun shafts, a swelling sun-bloom + warm-sand bed, a gentle aqua sea-shimmer field,
 *  drifting sea-spray on a sea-breeze, a low water-line shimmer, layered palm-frond silhouettes over
 *  a warm sand foreground, a light vignette, and a sunny grade. Breezy, cheerful, inviting — the
 *  contrast kept (no pale wash). */
export const COAST = forestBiome({
  id: 'coast',
  sky: { from: 0x7ec4e8, to: 0xf2e3b4 },
  celestial: { atX: 0.74, atY: 0.15, color: P.sunHaze, haloColor: 0xffe39a, size: 92, haloScale: 3.0, coreAlpha: 0.85, haloAlpha: 0.22 },
  cloudBands: { count: 4, color: 0xfdfaf0, sizeMin: 380, sizeMax: 700, alphaMin: 0.05, alphaMax: 0.13, driftPxPerSec: 6, bandYMin: 0.06, bandYMax: 0.30 },
  motes: { colors: [0xeaf7ff, P.crystal, P.sunHaze], textureKey: 'sparkle', driftPx: 44 },
  rays: { color: P.sunHaze, tiltDeg: 10, alphaMin: 0.09, alphaMax: 0.30 },
  glow: {
    blobs: [
      { color: P.sunHaze, atX: 0.74, atY: 0.13, size: 440, alpha: 0.08 },
      { color: 0xf2dca0, atX: 0.5, atY: 0.97, size: 620, alpha: 0.08 },
    ],
    breathe: { periodMs: 6500, min: 0.85, max: 1.2 },
  },
  lightField: { palette: [P.deepTeal, P.crystal, P.sunHaze] },
  weather: { mode: 'fall', color: 0xeaf7ff, colorEnd: 0xc9e8f0, lifespanMs: 5000, windX: 52, gust: { periodMs: 7500, min: 0.5, max: 1.45, phase: 0.3 } },
  flicker: { color: 0xaee7f0, baseAlpha: 0.06, flickerAmp: 0.05 },
  extraLayers: [
    { kind: 'caustics', color: 0xbdeeff, count: 6, sizeMin: 220, sizeMax: 420, alphaMin: 0.07, alphaMax: 0.24, bandYMin: 0.74, bandYMax: 0.95, driftPx: 40, periodMinMs: 3000, periodMaxMs: 6500 },
  ],
  parallax: [
    { svg: LANDSCAPE_BACKDROPS.coast.far, shape: 'peaks', color: 0x6f9e86, speed: 0.04, height: 320, alpha: 0.66, detail: 0.7, sway: { ampPx: 10, periodMs: 28000 } },
    { svg: LANDSCAPE_BACKDROPS.coast.mid, shape: 'peaks', color: 0x4a7d5e, speed: 0.10, height: 240, alpha: 0.82, detail: 1.0 },
    { svg: LANDSCAPE_BACKDROPS.coast.near, shape: 'ridge', color: 0xd6b274, speed: 0.18, height: 150, alpha: 0.92, detail: 1.1 },
  ],
  closer: {
    vignette: { color: 0x2a4a5c, edgeAlpha: 0.2, washColor: 0x8fd0ec, washAlpha: 0.04 },
    grade: { top: 0xffe6a8, bottom: 0x8fcbe4, strength: 0.1, blend: 'normal' },
  },
});
